import { UsePatientSummaryApi } from "fe-common/patientSummary/useFetchPatientSummary";
import * as React from "react";
import { PatientSummaryAction } from "../types/SectionAction";

export interface UseCustomSummaryActionsProps {
  summaryApi: UsePatientSummaryApi;
  sectionActions?: PatientSummaryAction[];
  // onNotify?: (message: string) => void;
}

export const useCustomSummaryActions = ({
  summaryApi,
  ...props
}: UseCustomSummaryActionsProps) => {
  // Hijack all onclick events and inject it with patientSummary
  const mediatedActions = props.sectionActions?.reduce(
    (acc, action) => [
      ...acc,
      {
        ...action,
        onClick: (e: MouseEvent, section: string) =>
          action.onClick(e, summaryApi, section),
      },
    ],
    [],
  );

  return { mediatedActions };
};
